import type { FC } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

export type SlateRemoveModalProps = {
  onAccept: () => void;
  onCancel: () => void;
  visible: boolean;
};

export const SlateRemoveModal: FC<SlateRemoveModalProps> = ({ onAccept, onCancel, visible }) => (
  <ConfirmationModal
    message="Published slate images will not be removed from MediaCentral."
    onAccept={onAccept}
    onCancel={onCancel}
    title="Remove slate image"
    visible={visible}
  />
);
